<template>
    <i :class="classes" :style="styles" @click="handleClick"></i>
</template>
<script>
    const prefixClsI = 'ivu-icon';

    export default {
        name: 'Icon',
        props: {
            type: {
                type: String,
                default: ''
            },
            icon: {
                type: String,
                default: ''
            },
            prefixCls:{
                type: String,
                default: 'ihlp-icon-r'
            },
            size: [Number, String],
            color: String,
            custom: {
                type: String,
                default: ''
            }
        },
        computed: {
            classes () {
                return [
                    {
                        [`${prefixClsI}`]: this.type !== '',
                        [`${prefixClsI}-${this.type}`]: this.type !== '',
                        [`${this.prefixCls}`]: this.icon !== '',
                        [` i-${this.icon}`]: this.icon !== '',
                        [` ${this.custom}`]: this.custom !== '',
                    }
                ];
            },
            styles () {
                let style = {};

                if (this.size) {
                    style['font-size'] = `${this.size}px`;
                }

                if (this.color) {
                    style.color = this.color;
                }

                return style;
            }
        },
        methods: {
            handleClick (event) {
                this.$emit('click', event);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/common/icon/icon.vue